
import { DinamicComponents } from 'scorpion-core'

export function required(value) {
  return value ? undefined : 'Requerido'
}


export function getCustonComponenteField(custonForm, field) {
  let compF = null;
  custonForm.componenteRoot.componentes.forEach(c => {
    if (c.field === field) {
      let comp = DinamicComponents.getDinamicComponente(c.typeComponente)
      compF = comp;
    }

  })
  return compF;
}
export function getConfigComponente(custonForm, field) {
  let compF = null;
  custonForm.componenteRoot.componentes.forEach(c => {
    if (c.field === field) {
      compF = c;
    }

  })
  return compF;
}


// WEBPACK FOOTER //
// ./src/routes/sistema/function.js